/**
 * Base layout component with navigation and header
 */

import { useAuth } from "@/hooks/useAuth";
import { KeyRound, LogOut, Settings } from "lucide-react";
import { Link, Outlet, useNavigate } from "react-router-dom";

export function Layout() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <KeyRound className="h-6 w-6 text-blue-600" />
              <h1 className="text-xl font-bold text-gray-900">Auth Manager</h1>
            </div>

            {isAuthenticated && (
              <nav className="flex items-center space-x-6">
                <Link to="/keys" className="flex items-center space-x-2 text-gray-600 hover:text-gray-900">
                  <KeyRound className="h-4 w-4" />
                  <span>API Keys</span>
                </Link>
                <Link to="/settings" className="flex items-center space-x-2 text-gray-600 hover:text-gray-900">
                  <Settings className="h-4 w-4" />
                  <span>Settings</span>
                </Link>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="flex items-center space-x-2 text-gray-600 hover:text-gray-900"
                >
                  <LogOut className="h-4 w-4" />
                  <span>Logout</span>
                </button>
              </nav>
            )}
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
